/**
 * @generated SignedSource<<fa8ed6775f3b22a885f308f91b6d6a02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_user" | "PdpRespPricingGuidance_user" | "PdpRespSharedAboutItemPanel_user" | "PdpRespShippingReturns_user" | "PdpRespTabsCustomizationPanel_user" | "PdpSharedBuyerIncentives_user">;
  readonly " $fragmentType": "PdpRespDetailTabs_user";
};
export type PdpRespDetailTabs_user$key = {
  readonly " $data"?: PdpRespDetailTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_user",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTabsCustomizationPanel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3459a113ff33a3b3e72f94b2bfd24949";

export default node;
